import React from "react";

class BadExample extends React.Component {

    render() {
        return <div className="RedCode" onCopy={this.props.onCopy}>
            {this.props.children}
        </div>;
    }

}

export default BadExample;
